var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfHosted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 250,
    viewBox: "0 0 350 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H340C345.523 0 350 4.47715 350 10V250H0V10Z",
    fill: "#EFF0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.073 95.9676C195.543 95.9676 178.089 78.514 178.089 56.9838C178.089 35.4536 195.543 18 217.073 18C238.603 18 256.057 35.4536 256.057 56.9838C256.057 78.514 238.603 95.9676 217.073 95.9676Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.912 95.9676C198.382 95.9676 180.928 78.514 180.928 56.9838C180.928 35.4536 198.382 18 219.912 18C241.442 18 258.896 35.4536 258.896 56.9838C258.896 78.514 241.442 95.9676 219.912 95.9676Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.912 92.741C200.164 92.741 184.155 76.7319 184.155 56.9838C184.155 37.2356 200.164 21.2266 219.912 21.2266C239.66 21.2266 255.669 37.2356 255.669 56.9838C255.669 76.7319 239.66 92.741 219.912 92.741Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.456 92.741C210.421 92.741 202.286 76.7319 202.286 56.9838C202.286 37.2356 210.421 21.2266 220.456 21.2266C230.491 21.2266 238.626 37.2356 238.626 56.9838C238.626 76.7319 230.491 92.741 220.456 92.741Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.147 56.9819H255.669",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.546 74.5698C209.027 74.5698 199.572 76.879 193.026 80.5488C199.58 88.0128 209.19 92.7322 219.904 92.7322C230.486 92.7322 239.994 88.1294 246.541 80.8287C239.987 77.0034 230.33 74.5698 219.546 74.5698Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.479 34.0398C199.034 37.8961 208.721 40.3375 219.544 40.3375C230.623 40.3375 240.529 37.7795 247.083 33.7599C240.521 26.0937 230.787 21.2266 219.902 21.2266C208.892 21.2266 199.041 26.2103 192.479 34.0398Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.398 191.553L156.913 205.882C156.718 207.756 157.83 209.513 159.603 210.135L175.301 215.671C177.944 216.604 180.766 216.892 183.542 216.519L216.36 212.071C217.643 211.9 218.576 210.765 218.498 209.467C218.428 208.3 217.573 207.336 216.422 207.134L205.157 205.089C203.368 204.763 201.922 203.449 201.432 201.7L197.895 189.112L158.398 191.553Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M252.949 186.017L101.484 197.695C97.8223 197.975 94.689 195.098 94.689 191.444V77.2061C94.689 73.7462 97.5113 70.9395 100.995 70.9395H252.459C255.942 70.9395 258.765 73.7462 258.765 77.2061V179.766C258.765 183.039 256.23 185.761 252.949 186.017Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6871 191.444V77.2061C94.6871 73.7462 97.455 70.9395 100.876 70.9395H97.004C93.5908 70.9395 90.8151 73.7462 90.8151 77.2061V191.444C90.8151 195.098 93.8863 197.975 97.4783 197.695L99.5309 197.532C96.7863 196.91 94.6871 194.461 94.6871 191.444Z",
    fill: "url(#paint4_linear_0_1)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160.849,
    height: 107.482,
    transform: "matrix(-1 0 0 1 257.127 73.9512)",
    fill: "url(#paint5_linear_0_1)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.042 103.697L205.599 103.573C205.552 103.246 205.49 102.92 205.482 102.578C205.358 98.1227 208.506 94.414 212.495 94.3052C216.484 94.1963 219.827 97.734 219.943 102.189C219.951 102.531 219.905 102.858 219.881 103.184L224.437 103.06C224.469 103.06 224.492 103.075 224.523 103.075C224.538 102.741 224.554 102.399 224.538 102.057C224.344 94.9039 218.878 89.2281 212.347 89.4069C205.824 89.5858 200.669 95.5492 200.864 102.702C200.871 103.044 200.902 103.379 200.941 103.713C200.988 103.721 201.011 103.705 201.042 103.697Z",
    fill: "#C6E3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.615 127.419L200.203 128.134C199.877 128.142 199.597 127.901 199.589 127.598L198.959 104.312C198.952 104.009 199.208 103.752 199.542 103.744L225.954 103.029C226.281 103.021 226.561 103.262 226.568 103.565L227.198 126.852C227.206 127.155 226.942 127.404 226.615 127.419Z",
    fill: "#C6E3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M215.319 112.677C215.28 111.254 213.966 110.166 212.496 110.477C211.61 110.663 210.887 111.402 210.724 112.288C210.506 113.462 211.167 114.512 212.154 114.901L212.294 119.923C212.31 120.382 212.691 120.748 213.149 120.732H213.266C213.74 120.716 214.114 120.32 214.106 119.846L213.974 114.854C214.782 114.473 215.342 113.641 215.319 112.677Z",
    fill: "#68AFEC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.036 105.54L165.168 104.265L164.818 91.335L117.678 92.6178L118.036 105.54Z",
    fill: "#C6E3FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.48 121.874L165.612 120.591L165.262 107.661L118.13 108.944L118.48 121.874Z",
    fill: "#C6E3FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.97 139.828L166.102 138.545L165.744 125.615L118.612 126.898L118.97 139.828Z",
    fill: "url(#paint6_linear_0_1)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.044 146.529L240.501 144.966L240.252 135.799L182.795 137.362L183.044 146.529Z",
    fill: "#C6E3FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M183.394 159.265L240.852 157.702L240.603 148.536L183.138 150.098L183.394 159.265Z",
    fill: "#C6E3FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0116 127.844L125.968 114.315L179.965 127.844C179.965 127.844 180.633 155.15 171.871 188.948C163.109 222.745 125.975 236.826 125.975 236.826C125.975 236.826 81.8755 222.745 73.1131 188.948C64.3429 155.15 65.0116 127.844 65.0116 127.844Z",
    fill: "#8799AF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5592 127.844L125.959 114.315L182.359 127.844C182.359 127.844 183.012 155.15 174.413 188.948C165.814 222.745 125.951 236.826 125.951 236.826C125.951 236.826 86.0888 222.745 77.4897 188.948C68.9061 155.15 69.5592 127.844 69.5592 127.844Z",
    fill: "url(#paint7_linear_0_1)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0349 135.153L125.96 123.654L173.885 135.153C173.885 135.153 174.437 158.354 167.136 187.074C159.828 215.795 125.96 227.761 125.96 227.761C125.96 227.761 92.0843 215.795 84.7836 187.074C77.4829 158.361 78.0349 135.153 78.0349 135.153Z",
    fill: "url(#paint8_linear_0_1)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94.501 131.202C96.437 142.818 106.941 183.637 160.301 201.955C147.931 219.985 125.959 227.76 125.959 227.76C125.959 227.76 92.083 215.794 84.7823 187.073C77.4738 158.352 78.0336 135.152 78.0336 135.152L94.501 131.202Z",
    fill: "url(#paint9_linear_0_1)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M116.134 163.718C116.134 157.957 121.358 153.416 127.33 154.575C130.976 155.282 133.899 158.229 134.599 161.868C135.416 166.136 133.316 170.016 129.95 171.874C129.017 172.387 128.535 173.452 128.745 174.502L131.194 186.864C131.481 188.303 130.377 189.648 128.908 189.648H126.093H124.834H121.77C120.425 189.648 119.422 188.419 119.679 187.105L122.175 174.518C122.377 173.491 121.934 172.403 121.016 171.905C118.101 170.327 116.134 167.256 116.134 163.718Z",
    fill: "url(#paint10_linear_0_1)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M221.608 197.149H283.232C284.764 197.149 286 195.905 286 194.381V152.023C286 150.491 284.756 149.255 283.232 149.255H221.608C220.076 149.255 218.84 150.499 218.84 152.023V194.381C218.832 195.905 220.076 197.149 221.608 197.149Z",
    fill: "url(#paint11_linear_0_1)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M219.305 149.249H221.832C220.176 149.249 218.831 150.594 218.831 152.25V194.149C218.831 195.805 220.176 197.15 221.832 197.15H219.305C217.649 197.15 216.304 195.805 216.304 194.149V152.25C216.312 150.594 217.649 149.249 219.305 149.249Z",
    fill: "#7EBDE0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M231.489 168.366C231.489 168.366 232.865 168.591 233.658 168.716C233.961 168.762 234.241 168.56 234.296 168.257L234.677 165.979C234.793 165.271 235.462 164.797 236.162 164.914L236.333 164.945C237.079 165.069 237.584 165.777 237.46 166.523L237.398 166.896C237.336 167.262 237.584 167.604 237.95 167.666L239.303 167.891C239.676 167.954 240.026 167.705 240.088 167.332L240.158 166.927C240.275 166.204 240.959 165.722 241.682 165.839L241.915 165.878C242.615 165.994 243.089 166.655 242.973 167.355L242.592 169.625C242.537 169.944 242.755 170.255 243.074 170.302L259.284 173.007C259.292 173.007 259.3 173.007 259.308 172.992C260.871 168.638 264.836 165.831 268.91 166.515C273.59 167.301 276.638 172.37 275.721 177.851C274.803 183.333 270.271 187.135 265.59 186.357C261.508 185.673 258.67 181.723 258.616 177.089C258.616 177.081 258.608 177.074 258.6 177.074L230.672 172.409C229.522 172.214 228.752 171.103 228.993 169.944C229.234 168.84 230.377 168.179 231.489 168.366ZM266.22 182.625C269.135 183.115 271.958 180.743 272.533 177.323C273.101 173.909 271.204 170.745 268.288 170.263C265.372 169.773 262.55 172.144 261.975 175.565C261.407 178.971 263.304 182.135 266.22 182.625Z",
    fill: "url(#paint12_linear_0_1)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M252.94 177.82L253.484 177.913C253.974 177.991 254.433 177.664 254.511 177.182L255.444 171.608C255.521 171.118 255.195 170.659 254.713 170.581L254.169 170.488C253.679 170.41 253.22 170.737 253.142 171.219L252.209 176.794C252.124 177.283 252.45 177.742 252.94 177.82Z",
    fill: "url(#paint13_linear_0_1)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M249.155 177.191L249.699 177.284C250.189 177.362 250.648 177.035 250.725 176.553L251.658 170.979C251.736 170.489 251.41 170.03 250.928 169.952L250.383 169.859C249.894 169.781 249.435 170.108 249.357 170.59L248.424 176.165C248.339 176.647 248.673 177.105 249.155 177.191Z",
    fill: "url(#paint14_linear_0_1)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6446 91.8931L124.279 91.9008C126.06 91.9008 127.506 90.4547 127.506 88.6742L127.514 58.2818C127.514 56.5013 126.068 55.0551 124.287 55.0551L90.6524 55.0474C88.872 55.0474 87.4258 56.4857 87.4258 58.2662L87.418 88.6586C87.418 90.4469 88.8642 91.8931 90.6446 91.8931Z",
    fill: "url(#paint15_linear_0_1)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3989 55.0474H90.9258C88.9976 55.0474 87.4348 56.6101 87.4348 58.5383L87.427 88.3943C87.427 90.3225 88.9898 91.8853 90.918 91.8853H88.3911C86.4629 91.8853 84.9002 90.3225 84.9002 88.3943L84.9079 58.5383C84.9079 56.6101 86.4707 55.0474 88.3989 55.0474Z",
    fill: "#004D8A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M117.569 68.8572C111.995 63.2748 102.945 63.2748 97.3699 68.8495",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M114.731 74.0719C110.72 70.06 104.212 70.0522 100.192 74.0641",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M111.437 78.8007C109.244 76.6081 105.691 76.6081 103.506 78.8007",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M231.987 103.804H279.368C280.9 103.804 282.136 102.56 282.136 101.036V67.3621C282.136 65.8305 280.892 64.5942 279.368 64.5942H231.987C230.455 64.5942 229.219 65.8382 229.219 67.3621V101.036C229.219 102.56 230.455 103.804 231.987 103.804Z",
    fill: "url(#paint16_linear_0_1)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M229.6 64.5869H231.668C230.315 64.5869 229.211 65.6832 229.211 67.0438V101.347C229.211 102.7 230.307 103.804 231.668 103.804H229.6C228.247 103.804 227.143 102.708 227.143 101.347V67.0438C227.151 65.691 228.247 64.5869 229.6 64.5869Z",
    fill: "#7EBDE0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M259.869 84.4279C259.869 88.432 256.619 91.682 252.615 91.682H245.019C241.015 91.682 237.765 88.432 237.765 84.4279C237.765 80.4238 241.015 77.1738 245.019 77.1738H252.615C256.619 77.1738 259.869 80.4238 259.869 84.4279ZM245.26 80.1672C242.904 80.1672 240.999 82.0721 240.999 84.4279C240.999 86.7837 242.904 88.6886 245.26 88.6886H252.359C254.714 88.6886 256.619 86.7837 256.619 84.4279C256.619 82.0721 254.714 80.1672 252.359 80.1672H245.26Z",
    fill: "url(#paint17_linear_0_1)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M257.591 77.2386C257.801 77.2231 258.019 77.2075 258.237 77.2075H265.833C269.837 77.2075 273.087 80.4575 273.087 84.4616C273.087 88.4657 269.837 91.7156 265.833 91.7156H258.237C254.233 91.7156 250.983 88.4657 250.983 84.4616C250.983 80.6752 253.883 77.5729 257.591 77.2386ZM259.387 80.2009H258.485C256.13 80.2009 254.225 82.1058 254.225 84.4616C254.225 86.8174 256.13 88.7223 258.485 88.7223H265.584C267.94 88.7223 269.845 86.8174 269.845 84.4616C269.845 82.1058 267.94 80.2009 265.584 80.2009H259.387Z",
    fill: "url(#paint18_linear_0_1)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M256.627 84.4279C256.627 82.0721 254.722 80.1672 252.366 80.1672H247.414C245.011 78.55 243.619 77.1738 245.019 77.1738H252.615C256.619 77.1738 259.869 80.4238 259.869 84.4279C259.869 85.5086 258.501 85.4697 256.588 84.8555C256.596 84.7156 256.627 84.5756 256.627 84.4279Z",
    fill: "url(#paint19_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 256.058,
    y1: 56.9832,
    x2: 178.092,
    y2: 56.9832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7321,
    stopColor: "#075F9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 182.506,
    y1: 49.2935,
    x2: 258.891,
    y2: 64.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001041,
    stopColor: "#00BBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B87D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 189.512,
    y1: 251.52,
    x2: 187.226,
    y2: 196.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4012,
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004D8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 258.466,
    y1: 158.749,
    x2: 102.159,
    y2: 112.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6281,
    stopColor: "#176FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 95.8247,
    y1: 77.5422,
    x2: 95.2222,
    y2: 195.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9837,
    stopColor: "#0E1B5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 13.1265,
    y1: 0.048831,
    x2: 155.126,
    y2: 107.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ACFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7198EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 165.924,
    y1: 132.079,
    x2: 118.791,
    y2: 133.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_1",
    x1: 182.379,
    y1: 175.568,
    x2: 69.55,
    y2: 175.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0181,
    stopColor: "#E5F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD3D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_1",
    x1: 173.903,
    y1: 175.709,
    x2: 78.0283,
    y2: 175.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001041,
    stopColor: "#00BBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B87D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_1",
    x1: 160.303,
    y1: 179.482,
    x2: 78.0269,
    y2: 179.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27AAE1",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C75BC",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_1",
    x1: 134.78,
    y1: 172.027,
    x2: 116.133,
    y2: 172.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0181,
    stopColor: "#E5F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD3D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_1",
    x1: 283.998,
    y1: 163.929,
    x2: 218.178,
    y2: 183.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAEBEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_1",
    x1: 275.883,
    y1: 175.682,
    x2: 228.955,
    y2: 175.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5501,
    stopColor: "#075F9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_1",
    x1: 255.46,
    y1: 174.198,
    x2: 252.194,
    y2: 174.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7321,
    stopColor: "#075F9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_1",
    x1: 251.677,
    y1: 173.567,
    x2: 248.411,
    y2: 173.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7321,
    stopColor: "#075F9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_0_1",
    x1: 123.224,
    y1: 65.1916,
    x2: 78.0799,
    y2: 88.9247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A91F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004D8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_0_1",
    x1: 280.609,
    y1: 76.8768,
    x2: 228.638,
    y2: 92.1298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAEBEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_0_1",
    x1: 259.865,
    y1: 84.4286,
    x2: 237.762,
    y2: 84.4286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7321,
    stopColor: "#075F9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_0_1",
    x1: 273.087,
    y1: 84.4662,
    x2: 250.983,
    y2: 84.4662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001041,
    stopColor: "#00BBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B87D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_0_1",
    x1: 259.865,
    y1: 81.2308,
    x2: 244.458,
    y2: 81.2308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5501,
    stopColor: "#075F9B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfHosted);
export default __webpack_public_path__ + "static/media/SelfHosted.8b1e0547add46e1471d2fbe6f0c01963.svg";
export { ForwardRef as ReactComponent };